const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#fcb525',
                contrastText: '#000',
                hover: '#e2a321'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
